import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

const BulletPointIcon = () => (
  <div data-testid={applyDataTestId(pom.icons.bulletPointIcon)} className="hidden sm:flex items-center px-1">
    <svg
      width={5}
      height={5}
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50241 4.522C1.48041 4.522 0.710406 3.724 0.710406 2.73C0.710406 1.75 1.48041 0.938 2.50241 0.938C3.53841 0.938 4.29441 1.75 4.29441 2.73C4.29441 3.724 3.53841 4.522 2.50241 4.522Z"
        fill="#373737"
      />
    </svg>
  </div>
);
export default BulletPointIcon;
